import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import ArticleDetailContent from './ArticleDetailContent';
import ArticleDetailHeader from './ArticleDetailHeader';
import { getConfigByCode } from 'y4/Falcon';
import { getQuery } from 'y4/Utils';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

const ArticleDetail = () => {
  const { t } = useTranslation('article');

  const location = useLocation();
  const code = getQuery(location.search, 'code');
  const [article, setArticle] = useState({
    title: t('Loading....'),
    caption: t('Article is still loading, please wait')
  });
  useEffect(() => {
    getConfigByCode(code).then(cs => {
      if (_.isEmpty(cs)) {
        setArticle({
          title: '404',
          caption: 'The article no longer exists'
        });
      } else {
        setArticle(cs[0]);
      }
    });
  }, []);

  return (
    <>
      <ArticleDetailHeader article={article} />
      <Row className="g-3">
        <Col>
          <ArticleDetailContent article={article} />
        </Col>
        {/**
        <Col lg={10}>
          <ArticleDetailContent article={article} />
        </Col>
        <Col lg={2}>
          <ArticleDetailAside article={article} />
        </Col>
         */}
      </Row>
    </>
  );
};

export default ArticleDetail;
